import { render, staticRenderFns } from "./AssetsIndex.vue?vue&type=template&id=89e758fc"
import script from "./AssetsIndex.vue?vue&type=script&lang=js"
export * from "./AssetsIndex.vue?vue&type=script&lang=js"
import style0 from "./AssetsIndex.vue?vue&type=style&index=0&id=89e758fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports